import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { REFUND_REASONS, REFUND_STATUS } from '@/pages/AdminShippingRefunds';

const fmt = (n) => `$${Number(n || 0).toLocaleString('es-CO')}`;

export const SellerShippingRefunds = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/sellers/me/shipping-refunds').then(({ data }) => setItems(data.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="mt-6 border border-slate-200 bg-white p-5" data-testid="seller-shipping-refunds">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Reembolsos de envío de tus pedidos</div>
      <p className="mt-1 text-xs text-slate-500">La parte que asumes se mostraría como descuento en tu desembolso cuando AutoMarket lo active; hoy es informativa.</p>
      <table className="mt-2 w-full text-xs">
        <thead className="text-left text-slate-500"><tr><th className="py-1 pr-3">Pedido</th><th className="pr-3">Motivo</th><th className="pr-3">Al comprador</th><th className="pr-3">Tu parte</th><th>Estado</th></tr></thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.shipping_refund_id} className="border-t border-slate-100" data-testid={`seller-srf-${r.shipping_refund_id}`}>
              <td className="py-1 pr-3 font-mono">{r.order_id}</td><td className="pr-3">{REFUND_REASONS[r.reason]}</td>
              <td className="pr-3">{fmt(r.amount_to_buyer)}</td><td className="pr-3">{fmt(r.seller_amount)}</td><td>{REFUND_STATUS[r.status]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
